import React from 'react';
import PropTypes from 'prop-types';

import { withFullScreenWithSummaryBarNavRefresh } from '@bingads-webui-react/app-layout-container';
import { withServerContext } from '@bingads-webui-campaign-react/server-context';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { withGlobalErrorView } from '@bingads-webui-campaign-react/global-error-options';

import { withCcJsDataContextProvider } from '../contexts/with-cc-js-data-context-provider';
import { withLegacyContext } from '../legacy-dep-bootstrap/legacy-context';
import { lazyLoad, withContexts } from './utils';
import { withPagePerfMarker } from '../contexts/with-page-perf-marker';
import { routes } from './dynamic-routes';

const StyledSiteExclusionListsCreate = withCcJsDataContextProvider(withLegacyContext(withFullScreenWithSummaryBarNavRefresh(withGlobalErrorView(withPagePerfMarker(lazyLoad(routes.SiteExclusionListCustomerCreationShell, c => withContexts(withServerContext(c))), 'Route_SiteExclusionList_CustomerCreation_VNext')))));
const StyledWebsiteExclusionListsCreateV2 = withFullScreenWithSummaryBarNavRefresh(withPagePerfMarker(lazyLoad(routes.WebsiteExclusionListsPage), 'Route_SiteExclusionList_CustomerCreation_VNext'));

const StyledSiteExclusionListsEdit = withCcJsDataContextProvider(withLegacyContext(withFullScreenWithSummaryBarNavRefresh(withGlobalErrorView(withPagePerfMarker(lazyLoad(routes.SiteExclusionListCustomerEditPage, c => withContexts(withServerContext(c))), 'Route_SiteExclusionList_CustomerEdit_VNext')))));
const StyledWebsiteExclusionListsEditV2 = withFullScreenWithSummaryBarNavRefresh(withPagePerfMarker(lazyLoad(routes.WebsiteExclusionListsCustomerEditPage), 'Route_SiteExclusionList_CustomerEdit_VNext'));

const StyledSiteExclusionListsViewLists = withCcJsDataContextProvider(withLegacyContext(withFullScreenWithSummaryBarNavRefresh(withGlobalErrorView(withPagePerfMarker(lazyLoad(routes.SiteExclusionListAccountLevelListPage, c => withContexts(withServerContext(c))), 'Route_SiteExclusionList_AccountLevel_ListPage_VNext')))));
const StyledWebsiteExclusionListsViewListsV2 = withFullScreenWithSummaryBarNavRefresh(withPagePerfMarker(
  lazyLoad(routes.WebsiteExclusionListsAccountLevelListPage),
  'Route_SiteExclusionList_AccountLevel_ListPage_VNext'
));

const StyledSiteExclusionListsViewExclusions = withCcJsDataContextProvider(withLegacyContext(withFullScreenWithSummaryBarNavRefresh(withGlobalErrorView(withPagePerfMarker(lazyLoad(routes.SiteExclusionListAccountLevelExclusionsPage, c => withContexts(withServerContext(c))), 'Route_SiteExclusionList_AccountLevel_ExclusionsPage_VNext')))));
const StyledWebsiteExclusionListsViewExclusionsV2 = withFullScreenWithSummaryBarNavRefresh(withPagePerfMarker(lazyLoad(routes.WebsiteExclusionListsAccountLevelExclusionsPage), 'Route_SiteExclusionList_AccountLevel_ExclusionsPage_VNext'));

// Generic higher-order component for conditional rendering
const websiteExclusionListsPermissions = (ComponentV1, ComponentV2) => {
  const WebsiteExclusionListsConditional = ({ permissions }) => {
    const {
      dynamic: { WebsiteExclusionLists },
    } = permissions;

    return WebsiteExclusionLists ? <ComponentV2 /> : <ComponentV1 />;
  };

  WebsiteExclusionListsConditional.propTypes = {
    permissions: PropTypes.shape({
      dynamic: PropTypes.shape({
        WebsiteExclusionLists: PropTypes.bool,
      }),
    }).isRequired,
  };

  return withPermissions(WebsiteExclusionListsConditional);
};

const WebsiteExclusionListsCreateShell = websiteExclusionListsPermissions(StyledSiteExclusionListsCreate, StyledWebsiteExclusionListsCreateV2);
const WebsiteExclusionListsEditShell = websiteExclusionListsPermissions(StyledSiteExclusionListsEdit, StyledWebsiteExclusionListsEditV2);
const WebsiteExclusionListsViewListsShell = websiteExclusionListsPermissions(StyledSiteExclusionListsViewLists, StyledWebsiteExclusionListsViewListsV2);
const WebsiteExclusionListsViewExclusionsShell = websiteExclusionListsPermissions(StyledSiteExclusionListsViewExclusions, StyledWebsiteExclusionListsViewExclusionsV2);

export { WebsiteExclusionListsCreateShell, WebsiteExclusionListsEditShell, WebsiteExclusionListsViewListsShell, WebsiteExclusionListsViewExclusionsShell };
